import { render, staticRenderFns } from "./number-scroll.vue?vue&type=template&id=8a669920&scoped=true"
import script from "./number-scroll.vue?vue&type=script&lang=js"
export * from "./number-scroll.vue?vue&type=script&lang=js"
import style0 from "./number-scroll.vue?vue&type=style&index=0&id=8a669920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a669920",
  null
  
)

export default component.exports